import {
  NewRegistrationHighSchool,
  NewRegistrationAttachment,
  NewRegistrationUniversity,
  NewRegistrationProject,
  NewRegistrationLanguage,
  NewRegistrationWorkExperience,
  NewRegistrationSkills,
} from '../../new-registration.model';
import { Address } from '../../address.model';
import { DriversLicenses } from '../user-from-be';
import { CandidateAISummary } from '../candidate-detail/candidate-ai-summary.model';

export class FinalCandidateHRCvrModel {
  id?: number;
  uuid?: string;
  createdAt?: string;
  status!: string;
  gender!: string;
  name!: string;
  surname!: string;
  title!: string;
  titleAfterName?: string;
  birthDate!: Date;
  email!: string;
  telephoneNumber!: string;
  address!: Address;
  educationLevelID?: number;
  hrHighSchoolEducations!: NewRegistrationHighSchool[];
  hrUniversityEducations!: NewRegistrationUniversity[];
  // courses!: NewRegistrationCourse[];
  projects!: NewRegistrationProject[];
  hrLanguages!: NewRegistrationLanguage[];
  hrWorkExperiences!: NewRegistrationWorkExperience[];
  hrSkills!: NewRegistrationSkills[];
  hrDriversLicenses?: DriversLicenses;
  jobType?: string | string[];
  jobCategory?: string | string[];
  selfDescription?: string | string[];
  profilePictureId!: Number;
  anonymized?: boolean;
  summaries: CandidateAISummary[];
}
